import styles from "./styles.module.scss";

const ThreeDots = () => (
    <div className={styles.flashing}></div>
)

export default ThreeDots;